var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"40px"}},[_c('el-table',{staticClass:"tableEl",attrs:{"data":_vm.yjzy.data,"header-row-style":{
		backgroundImage:`url(${_vm.headerBg})`,
		backgroundRepeat: 'no-repeat',
		backgroundSize: '100% 100%',
		color:'#000'
	},"header-cell-style":{
		background:'none'
	},"border":false}},_vm._l((_vm.yjzy.head),function(item,index){return _c('el-table-column',{key:index,attrs:{"prop":item.value,"label":item.label,"min-width":"100"}})}),1),(_vm.yjzy.dw)?_c('div',{staticClass:"yjzydw"},[_vm._v("\n\t\t"+_vm._s(_vm.yjzy.dw)+"\n\t")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }